<template>
  <div class="container">
    <el-card style="margin:20px">
      <el-row>
        <el-col :span="20">
          <el-form :inline="true" :model="searchParams">
            <el-form-item>
              <el-input placeholder="请输入关键词" type="text" size="small" v-model="searchParams.name"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="请选择国家" size="small" v-model="searchParams.country"
                clearable filterable>
                <el-option
                  v-for="country in countryConfig"
                  :key="country.country_code2"
                  :value="country.country_code2">
                  <span style="float: left">{{ country.country_code2 }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ country.name_zh }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="请选择语言" type="text" size="small" v-model="searchParams.lang"
                clearable filterable>
                <el-option
                  v-for="lang in langConfig"
                  :key="lang.lang"
                  :value="lang.lang">
                  <span style="float: left">{{ lang.lang }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ lang.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="searchParams.status" size="small" placeholder="请选择状态" clearable>
                <el-option key="1" label="启用" :value="1"></el-option>
                <el-option key="-1" label="禁用" :value="-1">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                icon="el-icon-search"
                @click="queryWords">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addWord">新增关键词</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="batchAddWords">批量添加</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin: 0 20px">
      <div v-for="(v, k) in wordMap">
        <el-divider><b>{{k}}</b></el-divider>
        <el-row>
          <el-col :offset="2" :span="20">
            <span v-for="word in v" @click="editWord(word)" style="cursor: pointer">
              {{word.name}}<span v-if="word.disabled">(已禁用)</span>,
            </span>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="detailDialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="wordForm" :rules="wordFormRules" :model="wordForm" label-width="200px">
        <el-form-item label="关键词" prop="name" v-if="!batch">
          <el-input v-model="wordForm.name"></el-input>
        </el-form-item>
        <el-form-item label="多个关键词(换行符区分)" prop="names" v-if="batch">
          <el-input v-model="wordForm.names" type='textarea'></el-input>
        </el-form-item>
        <el-form-item label="国家" prop="countries">
					<el-select v-model="wordForm.countries" clearable filterable multiple>
            <el-option
              v-for="country in countryConfig"
              :key="country.country_code2"
              :value="country.country_code2">
              <span style="float: left">{{ country.country_code2 }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ country.name_zh }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语言" prop="lang">
          <el-select v-model="wordForm.lang" clearable filterable>
            <el-option
              v-for="lang in langConfig"
              :key="lang.lang"
              :value="lang.lang">
              <span style="float: left">{{ lang.lang }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ lang.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-select v-model="wordForm.disabled">
            <el-option key="false" label="启用" :value="false"></el-option>
            <el-option key="true" label="禁用" :value="true"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!--el-button v-if="wordForm.id" @click="deleteWord(wordForm)" type="danger"
          style='float: left'>删 除</el-button-->
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const WordStatus = {
  '-1': '禁用',
  '0' : '',
  '1' : '启用'
}

  export default {
    data () {
      return {
        searchParams: {
          country: '',
          lang: '',
          status: 1,
          name: '',
          limit: 500
        },
        batch: false,
        word: {},
        wordMap: {},
        wordForm: {},
        dialogTitle: '',
        countryConfig: require('@/assets/config/country'),
				langConfig: require('@/assets/config/lang'),
        detailDialogVisible: false,
        wordFormRules: {
          name: [
            { required: true, message: '请输入关键词', trigger: 'blur' },
          ],
          names: [
            { required: true, message: '请输入关键词', trigger: 'blur' },
          ],
          countries: [
            { required: true, message: '请输入国家', trigger: 'change' }
          ],
          lang: [
            { required: true, message: '请输入语言', trigger: 'change' }
          ],
          disabled: [
            { required: true, message: '请选择是否禁用', trigger: 'change' }
          ]
        }
      }
    },
    methods:{
      async queryWords() {
        let searchParams = this.searchParams;
        let status = this.searchParams.status || 0;
        let url = `/etp/word/list?name=${searchParams.name}&country=${searchParams.country}&lang=${searchParams.lang}&status=${status}`;

        let res = await this.$http.get(url);
        let words = res.data.data || [];

        let wordMap = {};
        words.forEach((w) => {
          w.countries.forEach((country) => {

            if (this.searchParams.country && country != this.searchParams.country) {
              return
            }

            if (this.searchParams.lang && w.lang != this.searchParams.lang) {
              return
            }

            let k = `国家: ${country}, 语言: ${w.lang}`;
            wordMap[k] = wordMap[k] || [];
            let t = '';
            if (w.status == -1) {
              t = '(已禁用)'
            }

            wordMap[k].push(w);

          })
        })

        this.wordMap = wordMap;
      },
      changePage() {
      },
      addWord() {
        this.batch = false;
        this.dialogTitle = '新增关键词';
        this.wordForm = { disabled: false };
        this.detailDialogVisible = true;
      },
      batchAddWords() {
        this.batch = true;
        this.dialogTitle = '批量新增关键词';
        this.wordForm = { disabled: false };
        this.detailDialogVisible = true;
      },
      editWord(w) {
        this.batch = false;
        this.dialogTitle = '编辑关键词';
        this.wordForm = JSON.parse(JSON.stringify(w));
        this.detailDialogVisible = true;
      },
      handleClose() {
        this.batch = false;
        this.detailDialogVisible = false;
      },
      async submit() {

        let data = JSON.parse(JSON.stringify(this.wordForm));

        if (!this.batch) {
          let rst = await this.$http.post('/etp/word/save', JSON.stringify(data));
          if (rst.data.err_code == 0) {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success'
            })
            this.detailDialogVisible = false;
            this.queryWords();
          }
        } else {

          data.name = data.names.split('\n');
          let rst = await this.$http.post('/etp/word/batch/save', JSON.stringify(data));
          if (rst.data.err_code == 0) {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success'
            })
            this.detailDialogVisible = false;
            this.queryWords();
          }

          this.batch = false;

        }

      },
      async deleteWord (word) {
        this.$confirm(`确认删除${word.name}?`)
          .then(async () => {
            let rst = await this.$http.post('/etp/word/delete', { id: [word.id] });

            if (rst.data.err_code == 0) {
              this.$notify({
                title: '提示',
                message: '删除成功',
                type: 'success'
              })
            }

            this.detailDialogVisible = false;
            this.queryWords();

          })
          .catch(_ => {
            this.detailDialogVisible = false;
            this.queryWords();
          });
      },
    },
    mounted() {
      this.queryWords();
    }
  }
</script>
